import { useMutation } from '@tanstack/react-query'
import { ErrorModel } from '@/shared/api/BaseAPI.model'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from '@/shared/components/Snackbar/SnackbarProvider'
import DevicesAPI from '../api/DevicesAPI'
import {
  RegisterDevicePayload,
  RegisterDeviceResponse
} from '../api/DevicesAPI.model'

export function useDeviceRegister() {
  const { t } = useTranslation()
  const { showSnackbar } = useSnackbar()

  const { mutateAsync: registerDevice, isPending: isRegistering } = useMutation<
    RegisterDeviceResponse,
    ErrorModel,
    RegisterDevicePayload
  >({
    mutationFn: (payload: RegisterDevicePayload) =>
      DevicesAPI.registerDevice(payload),
    onError: () => {
      showSnackbar(
        t('ALERTS.REGISTER_DEVICE_ERROR.TITLE'),
        t('ALERTS.REGISTER_DEVICE_ERROR.DESCRIPTION'),
        'error'
      )
    }
  })

  return {
    registerDevice,
    isRegistering
  }
}
